import React from "react";

/*
* This component is used to display JSON data in a formatted way.
*/
export default function JsonFormattedDisplay({ data }) {
  const deepParseJSONStrings = (obj) => {
    if (typeof obj === 'string') {
      try {
        const parsed = JSON.parse(obj);
        return deepParseJSONStrings(parsed);
      } catch {
        return obj;
      }
    }

    if (Array.isArray(obj)) {
      return obj.map(deepParseJSONStrings);
    }

    if (typeof obj === 'object' && obj !== null) {
      const parsedObj = {};
      for (const key in obj) {
        parsedObj[key] = deepParseJSONStrings(obj[key]);
      }
      return parsedObj;
    }

    return obj;
  };

  const parsed = deepParseJSONStrings(data);

  return (
    <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {JSON.stringify(parsed, null, 2)}
    </pre>
  );
}
